/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Cookie } from '../../models/cookie';

export interface ApiMasterCookieGetCookieGet$Params {
}

export function apiMasterCookieGetCookieGet(http: HttpClient, rootUrl: string, params?: ApiMasterCookieGetCookieGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Cookie>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCookieGetCookieGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Cookie>;
    })
  );
}

apiMasterCookieGetCookieGet.PATH = '/api/Master/Cookie/GetCookie';
